import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import Current from 'frontend/lib/current'
import ky from 'lib/ky'

export default class SuggestedRoomSelect extends Component {
  static propTypes = {
    template: PropTypes.object,
    selected: PropTypes.bool,
    selectedId: PropTypes.number,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.state = { rooms: [] }
  }

  componentDidMount () {
    this.fetchRooms()
  }

  async fetchRooms () {
    try {
      const rooms = await ky.get(`/${Current.cityId}/escape-rooms.json`).json()
      this.setState({ rooms })
    } catch (error) {
      console.error('SuggestedRoomSelect#fetchRooms() error', error)

      this.setState({ errorMessage: 'Error fetching rooms from the server.' })
    }
  }

  renderPlaceholder () {
    if (this.props.selected) {
      return this.renderLabel(this.props.selected)
    } else if (this.props.selectedId) {
      return this.renderLabel(this.state.rooms.find((room) => room.id === this.props.selectedId))
    } else {
      return <h5 className="placeholder">Please select</h5>
    }
  }

  renderLabel (room) {
    return (
      <div className="room_option">
        <h5 className="room_name">{room.name}</h5>
        <div className="location_address">{room.location.address.local}</div>
      </div>
    )
  }

  get options () {
    const options = []

    this.state.rooms.forEach((room) => {
      options.push({ label: this.renderLabel(room), value: room })
    })

    return options
  }

  render () {
    if (this.state.errorMessage) {
      return <div className="error">{this.state.errorMessage}</div>
    } else if (this.state.rooms) {
      return (
        <Select
          className="suggested_room_select"
          searchable={false}
          clearable={false}
          name="suggestedRoom"
          disabled={this.props.disabled}
          placeholder={this.renderPlaceholder()}
          options={this.options}
          onChange={this.props.onSelect}
        />
      )
    } else {
      return <div className="spinner">Loading...</div>
    }
  }
}
